module.exports = __webpack_public_path__ + "img/1516334252.d1281ed4.jpg";